<template>
  <div>
    <div class="page">
      <img class="contract-logo" src="@/assets/images/contract_syncvault_logo.png" />
      <br>
      <br>
      <p class="paragraph tac">
        NON-EXCLUSIVE - PROMOTIONAL ARTIST SERVICE AGREEMENT
      </p>
      <p class="paragraph">
        This Agreement is made on the  [&emsp;&emsp;] day of [&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;]
        (the “<strong>Effective Date</strong>”)<br>
        Between<br>
        <strong>SoundVault Limited</strong> t/a “<strong>SyncVault</strong>”<br>
        of SoundVault LIMITED<br>
        303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom. Registered in England and Wales<br>
        No. 6602618<br>
        and<br>
        [&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;] (“<strong>Licensor</strong>”)<br>
        of [
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
        &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
        ]
      </p>
      <h2>BACKGROUND</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">(A)</p>
        <p class="paragraph">
          SoundVault facilitates promotional and licensing opportunities by promoting and making available
          sound recordings and compositions to third party subscribers and clients who may search and, if
          they choose, license any such sound recordings and compositions for various purposes including
          but not limited to synchronisation with images.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">(B)</p>
        <p class="paragraph">
          In consideration for SoundVault providing promotional and licensing opportunities through the
          SyncVault Website, the Licensor wishes to make certain Promotional Artist Tracks (as defined in
          Schedule 3 and / or via email from time to time) available to SoundVault and the Licensor has
          agreed that SoundVault may exploit such Promotional Artist Tracks on the SyncVault Website
          upon and subject to the terms and conditions of this Agreement.
        </p>
      </div>
      <h2>1. RIGHTS GRANTED BY LICENSOR</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.1.</p>
        <p class="paragraph">
          Licensor grants to SoundVault the non-exclusive right and licence in the Territory and for the Term to:
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(a)</p>
        <p class="paragraph">
          provide links to Promotional Artist Tracks held on SoundVault’s servers or a licensed
          third-party service to enable users to listen to Tracks for preview purposes;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(b)</p>
        <p class="paragraph">
          include the Promotional Artist Tracks freely within all SyncVault subscription services;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(c)</p>
        <p class="paragraph">
          grant Sub-Licences to Subscribers of extracts from Broadcast Quality Promotional Artist Tracks
          for the Licensed Usage (or any part thereof) as set out in Schedule 2;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(d)</p>
        <p class="paragraph">
          or SoundVault or its Subscribers the right to make copies, modifications and/or edits to the
          Promotional Artist Tracks as necessary solely for the purpose of promoting, licensing and
          incorporating the Promotional Artist Tracks within the applicable Licensed Usage in
          accordance with clause 1.1 (b) above; and
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(e)</p>
        <p class="paragraph">
          o use Track Metadata and Artist Materials and other data supplied by Licensor relating
          to the Promotional Artist Tracks to assist the search facility of the SyncVault Website
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(f)</p>
        <p class="paragraph">
          To use the name and likeness, biographical material, logos, trademarks photographs, symbols,
          emblems, designs, associated company names and logos, and any other visual representations
          of the Promotional Artist and any other individuals performing or otherwise represented or
          whose performance is embodied in the Promotional Artist Tracks, as well as track and/or
          album name, and all artwork related to the Promotional Artist Tracks audio-visual works
          that you provide, for use on our website, across our social media channels, within our
          on-site features, our YouTube channel, email marketing, paid media advertising across
          all social and digital channels and for general marketing and promotional purposes including but
          not limited printed materials and PR activity, in perpetuity.
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(g)</p>
        <p class="paragraph">
          To use any interviews we capture, or sessions we film for use on our website, across our social
          media channels, within our on-site features, our YouTube channel, email marketing, paid media
          advertising across all social and digital channels and for general marketing and promotional
          purposes including but not limited printed materials and PR activity, in perpetuity.
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.2.</p>
        <p class="paragraph">
          All Promotional Artist Tracks including Samples delivered to SoundVault under this agreement
          must be owned and / or controlled 100% by the Licensor including ownership of the sound recording
          and underlying composition.  (For the avoidance of doubt, in the event the composition is controlled
          in part by any other third-party the Licensor shall be responsible for obtaining written permission
          from any such third-party).
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.3.</p>
        <p class="paragraph">
          All Promotional Artist Tracks must be available for Sub-License by SoundVault throughout the Territory.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.4.</p>
        <p class="paragraph">
          All Promotional Artist Tracks that are used on videos that are published within the promotional period,
          grant the rights for those videos (only), to use the music in perpetuity.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.5.</p>
        <p class="paragraph">
          In accordance with clause 1.6, Licensor may at any time notify SoundVault via email to
          <a href="support@syncvault.com">support@syncvault.com</a>
          (or as otherwise notified by SoundVault in writing) of individual Promotional Artist Tracks
          which are no longer available for exploitation hereunder on a Track by Track basis.
          SoundVault shall make the applicable amendments to the SyncVault Website within 15 days from
          SoundVault’s receipt of Licensor’s notification PROVIDED THAT any such amendments shall
          be subject to previously granted licences.
        </p>
      </div>
      <br>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.6.</p>
        <p class="paragraph">
          To enable SoundVault to provide the services hereunder, Licensor shall promptly following
          signature deliver to SoundVault .wav files embodying the Promotional Artist Tracks a file
          transfer protocol and Licensor hereby grants to SoundVault the right to upload such Promotional
          Artist Tracks to the SyncVault Website for the purposes set out  herein.
        </p>
      </div>
    <h2>2. CONTENT ID MANAGEMENT</h2>
    <div class="paragraph-parent">
      <p class="paragraph-name">2.1.</p>
      <p class="paragraph">
        All Promotional Artist Tracks licensed under this agreement must be subject to active
        YouTube content identification (“Content ID”) management throughout each Campaign Term.
      </p>
    </div>
    <div class="paragraph-parent">
      <p class="paragraph-name">2.2.</p>
      <p class="paragraph">
        Throughout the campaign term the Promotional Artists Tracks are offered on the SyncVault Website
        as monetizable content and needs to be whitelisted to the subscriber channel.
      </p>
    </div>
    <div class="paragraph-parent">
      <p class="paragraph-name">2.3.</p>
      <p class="paragraph">
        Licensor must agree to:
      </p>
    </div>
    <div class="paragraph-parent pw">
      <p class="paragraph-name">(a)</p>
      <p class="paragraph">
        Complete SoundVault Content Manager Assignment Schedule 6 - to assign SoundVault as Content ID Manager
        to whitelist subscriber channel/s and collect all related YouTube ‘AdSense’ advertising revenues
        throughout the Term.
      </p>
    </div>
      <h2>3. LICENSOR WARRANTIES</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">3.1.</p>
        <p class="paragraph">
          The Licensor represents, warrants and undertakes to SoundVault that:
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(a)</p>
        <p class="paragraph">
          it is entitled to enter into, and grant the rights granted under, this Agreement;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(b)</p>
        <p class="paragraph">
          by entering into this Agreement, it is not, and shall not be throughout the Term,
          in conflict with any of its other obligations it may have to anyone else;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(c)</p>
        <p class="paragraph">
          the exercise by SoundVault of the rights granted under this Agreement and the exploitation
          of the Promotional Artist Tracks in accordance with its terms shall not in any way infringe
          the rights including any moral or other analogous rights in any jurisdiction anywhere
          in the world of any third party and/or will in any way be unlawful;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(d)</p>
        <p class="paragraph">
          SoundVault shall not be obliged to make any payment, fee and/or royalty in respect
          of the rights in the Promotional Artist Tracks expressly granted hereunder
          and exploited by SoundVault in accordance with this agreement;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(e)</p>
        <p class="paragraph">
          it shall ensure that all Promotional Artist Tracks and / or Track Metadata and / or
          Artist Materials uploaded to the SoundVault Server shall be free of all software viruses,
          worms, spyware, defects, Trojan horses or malicious code or items of a destructive
          nature or any computer code, files or programs designed to interrupt,
          destroy or limit the functionality of any computer software or hardware or telecommunications equipment;
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">2</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(f)</p>
        <p class="paragraph">
          all Promotional Artist Tracks uploaded shall be digitised at Broadcast Quality;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(g)</p>
        <p class="paragraph">
          it shall not set any Promotional Artist Tracks to have a default takedown registered
          with YouTube Content ID and / or any other user platform in relation to user generated
          content embodying all or part of such Track, and Licensor shall not and shall
          procure that its licensors (if any) shall not issue take down notices to any
          third party in respect of the properly licensed usage of Tracks hereunder; and
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(h)</p>
        <p class="paragraph">
          the metadata supplied by the Licensor in relation to the Promotional Artist Tracks
          shall be true and accurate to the best of Licensor’s knowledge; and
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(j)</p>
        <p class="paragraph">
          Licensor shall notify SoundVault promptly and keep SoundVault notified of any Promotional
          Artist Track(s) it no longer controls, it being understood that SoundVault may incur loss
          and damage as a result of Licensor’s failure to do so.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">3.2.</p>
        <p class="paragraph">
          If SoundVault receives or becomes aware of a claim or complaint that any Promotional Artist Track(s)
          infringe(s) the intellectual property and/or any other right of any third party,
          SoundVault shall be entitled without prejudice to SoundVault’s other rights and
          remedies to suspend the account of the Licensor and/or remove any or all
          Promotional Artist Tracks from the SyncVault Websites.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">3.3.</p>
        <p class="paragraph">
          If a Licensor is found to have infringed intellectual property rights and/or any other third party rights,
          SoundVault shall have the right to immediately terminate the Licensor’s access as a
          registered user of the SyncVault Website, and to remove all Tracks from the Website,
          without notice at any time. The Licensor shall agree that SoundVault shall not be liable
          to the Licensor or any third party for any termination of access to the SyncVault Website.
          SoundVault shall have the right to terminate this agreement in the event of persistent
          and / or material complaint or claim as above.
        </p>
      </div>
      <h2>4. SOUNDVAULT WARRANTIES AND SERVICES</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">4.1.</p>
        <p class="paragraph">
          SoundVault warrants and undertakes to the Licensor that it is free to enter into
          this Agreement and perform its obligations under this Agreement.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">4.2.</p>
        <p class="paragraph">
          SoundVault shall use reasonable commercial endeavours to:
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(a)</p>
        <p class="paragraph">
          provide adequate technical support to the Licensor in the uploading of its digitised content
          to be hosted on the SyncVault Website and / or the linking of Tracks hosted by Licensor’s own provider;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(b)</p>
        <p class="paragraph">
          maintain, update and manage the SyncVault Website to a professional standard,
          ensuring that industry standard security measures are put in place to keep Licensor’s Promotional
          Artist Tracks and Track Metadata accessible only to authorised SoundVault personnel;
          (for the avoidance of doubt, any  and all data obtained from the Licensor by SyncVault shall
          be stored, processed and used in accordance with the Data Protection Act 1999 or any
          legislation that replaces it in whole or in part and any other legislation relating to the protection
          of data such as the General Data Protection Regulation (GDPR));
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(c)</p>
        <p class="paragraph">
          ensure the Licensor’s Promotional Artist Tracks is not used in Content in connection with
          other material that is defamatory, obscene, immoral, discriminating, illegal,
          or that otherwise violates any rights of anyone associated with the Content and / or any third party;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(d)</p>
        <p class="paragraph">
          ensure the Licensors  Promotional Artists Tracks are licensed in accordance with an End User
          License Agreement on the website that warrants all rights of the owners of the music recordings,
          musical compositions and public performance in respect of the content on the Websites
          and the Services are reserved;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(e)</p>
        <p class="paragraph">
          ensure that the business information of the Licensor is kept confidential, and is not
          disclosed to any other client or supplier of SoundVault;
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(f)</p>
        <p class="paragraph">
          remove Promotional Artist Tracks from the SoundVault servers in accordance with Licensor’s instructions
          pursuant to 1.5 above as soon as reasonably practicable and within 15 business days following
          receipt of Licensor’s properly submitted request;
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">3</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(g)</p>
        <p class="paragraph">
          ensure that where this agreement provides for Licensor’s to carry out certain actions or provide certain
          instructions or notifications via the SyncVault Website, the SyncVault Website shall be capable
          of fulfilling the same; and
        </p>
      </div>
      <div class="paragraph-parent pw">
        <p class="paragraph-name">(h)</p>
        <p class="paragraph">
          shall provide Licensor with a weekly report of all licences and relevant documentation in relation
          to the use of Promotional Artist Tracks, as detailed in Schedule 3.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">4.3.</p>
        <p class="paragraph">
          For the avoidance of doubt nothing in this Agreement obliges SoundVault to Sub-Licence
          any of the Promotional Artist Tracks.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">4.4.</p>
        <p class="paragraph">
          SoundVault has the right to remove any Promotional Artist Tracks from the
          SyncVault Website at its absolute discretion.
        </p>
      </div>
      <h2>5. PROMOTIONAL ARTIST SERVICES</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">5.1.</p>
        <p class="paragraph">
          Promotional Artist Tracks can be sub-licensed to third parties with a Free Download via
          any subscription service offered on SyncVault Website during any given campaign term.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">5.2.</p>
        <p class="paragraph">
          Licensor grants SoundVault the right for their Tracks to be listened to and downloaded on
          the SyncVault website for promotional purposes only and for a set campaign term.
          In this regard Licensor grants SoundVault a waiver of any digital artist royalties,
          performance royalties, internet broadcast royalties, or any other fees or royalties,
          statutory or otherwise that Licensor may be obligated to pay Promotional Artist
          or a third party in connection with the use of such Promotional Artist Tracks,
          including but not limited to if Promotional Artist currently is or becomes a member
          of a performing rights licensing organisation (such as BMI, ASCAP, PRS, GEMA or SACEM);
        </p>
      </div>
      <h2>6. INDEMNITY</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">6.1.</p>
        <p class="paragraph">
          Each party undertakes to indemnify the other party and its parent, affiliated and subsidiary
          companies and their respective officers and directors, and keep  such party at all times fully
          indemnified from and against all actions, proceedings, claims, awards, demands, costs,
          damages and expenses (including, without limit, all reasonable legal costs) related to
          a third party claim incurred and/or suffered by the other party arising directly as a
          result of any breach or non-performance by a Party of any of its undertakings, representations,
          warranties and/or obligations under this Agreement.
        </p>
      </div>
      <h2>7. TERM AND TERMINATION</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">7.1.</p>
        <p class="paragraph">
          Unless and until terminated in accordance with its terms, this Agreement shall commence
          on the Effective Date for 12 months, and shall automatically renew every 12 months and until further notice.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">7.2.</p>
        <p class="paragraph">
          Either party may terminate this Agreement in writing, giving the other party at least 45 days notice.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">7.3.</p>
        <p class="paragraph">
          Either party may terminate the Agreement if the other party materially breaches its obligations hereunder;
          provided that if such breach is non-persistent and remediable, (a) the non-breaching party
          sends written notice to the breaching party describing the breach in reasonable detail,
          and (b) the breaching party does not cure the breach within thirty (30) days following
          its receipt of such notice.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">7.4.</p>
        <p class="paragraph">
          On termination of this Agreement for any reason, SoundVault shall, within 90 days of a written
          request by the Licensor destroy all copies of the Promotional Artist Tracks held on its
          servers and confirm this in writing to the Licensor.
        </p>
      </div>
      <h2>8. EFFECT OF TERMINATION</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">8.1.</p>
        <p class="paragraph">
          On termination of this Agreement all rights and licences granted under this Agreement
          shall cease and come to an end except that, without limitation, termination or expiry of
          this Agreement shall in no way affect any existing Sub-Licences concluded in
          accordance with the terms of this agreement prior to the effective date of
          termination or expiry of this Agreement.
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">4</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <h2>9. LIABILITY</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">9.1.</p>
        <p class="paragraph">
          Unless expressly stated otherwise in this Agreement and to the extent permitted by law,
          SoundVault does not give any other representation, warranty or recourse, express or implied and
          SoundVault hereby excludes all terms, representations and warranties that might otherwise
          be implied into this Agreement.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">9.2.</p>
        <p class="paragraph">
          SoundVault’s liability under this Agreement shall not exceed the Fee paid for the relevant
          Music relating to the warranty breached. SoundVault shall not be liable for any loss of
          profit or opportunity or for any indirect or consequential loss of any kind howsoever
          arising out of and/or in connection with this Agreement.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">9.3.</p>
        <p class="paragraph">
          Nothing in this Agreement shall exclude or limit either party’s liability for death or
          personal injury arising through negligence or for fraud or for anything else that may not be excluded by law.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">9.4.</p>
        <p class="paragraph">
          You indemnify SoundVault and keep SoundVault at all times fully indemnified from and
          against all actions, proceedings, claims, awards, demands, costs, damages and expenses
          (including, without limit, all legal costs) incurred and/or suffered by SoundVault
          however arising directly or indirectly as a result of any breach or non-performance
          by you of any of your undertakings, representations, warranties and/or obligations under this Agreement.
        </p>
      </div>
    <h2>10. DISCLAIMERS</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">10.1.</p>
        <p class="paragraph">
          You acknowledge and agree that the SyncVault Website and music player is provided "as is" and
          SoundVault disclaims all warranties express or implied, including but not limited to (a) implied
          warranties of merchantability or fitness for a particular purpose; (b) warranties as to the quality
          or performance of the materials, information, services, technology and/or content provided under
          or in connection with this Agreement, including but not limited to any limitations on user access
          to or use of content; and (c) warranties as to the performance of computers, technology and/or networks.
        </p>
      </div>
    <h2>11. ASSIGNMENT</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">11.1.</p>
        <p class="paragraph">
          Either party may transfer this Agreement and / or any of its rights and/or obligations
          under this Agreement to any third party provided that such third party agrees to be bound to this Agreement.
        </p>
      </div>
    <h2>12. FORCE MAJEURE</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">12.1.</p>
        <p class="paragraph">
          Neither party shall be liable to the other for any failure to perform any of its obligations under
          this Agreement due to circumstances beyond its control.
        </p>
      </div>
    <h2>13. GENERAL</h2>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.1.</p>
        <p class="paragraph">
          A person who is not a party to this Agreement has no right under the Contracts
          (Rights of Third Parties) Act 1999 to enforce any term of this Agreement.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.2.</p>
        <p class="paragraph">
          The failure of either party to enforce or to exercise at any time or for any period of
          time any term of or any right pursuant to this Agreement does not constitute, and shall
          not be construed as, a waiver of such term or right and shall in no way affect that party’s
          right later to enforce or to exercise it.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.3.</p>
        <p class="paragraph">
          If any provision or part-provision of this Agreement is or becomes invalid, illegal or unenforceable,
          it shall be deemed modified to the minimum extent necessary to make it valid, legal and enforceable.
          If such modification is not possible, the relevant provision or part-provision shall be deemed deleted.
          Any modification to or deletion of a provision or part-provision under this clause shall not affect
          the validity and enforceability of the rest of this Agreement.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.4.</p>
        <p class="paragraph">
          This Agreement contains all the terms agreed between the parties regarding its subject matter
          and supersedes any prior agreement, understanding or arrangement between the parties,
          whether oral or in writing.
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">5</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.5.</p>
        <p class="paragraph">
          Nothing in this Agreement is intended to or shall operate to create a
          partnership or joint venture of any kind between the parties or to
          authorise either party to act as agent for the other, and neither party shall have authority
          to act in the name or on behalf of or otherwise to bind the other in any way.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.6.</p>
        <p class="paragraph">
          No modification or variation by either party of this Agreement (or any document entered into
          pursuant to or in connection with this Agreement) shall be valid unless it is in writing and
          signed by or on behalf of each of the parties to this Agreement. Unless expressly set out herein,
          no modification or variation of this Agreement shall: (i) be valid if made by e-mail
          unless the party receiving the e-mail replies to such email and expressly agrees to
          such modification or variation to this Agreement (in such event physical signatures
          shall not be required by the parties; (ii) constitute or be construed as a general
          waiver of any provisions of this Agreement; and (iii) affect any rights, obligations
          or liabilities under this Agreement which have already accrued up to the date of
          such modification or waiver. The rights and obligations of the parties under this
          Agreement shall remain in full force and effect, except and only to the extent
          that they are so modified or varied.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.7.</p>
        <p class="paragraph">
          Any reference in this Agreement to any statute or statutory provision order or
          regulation shall be construed as including a reference to that statute or statutory
          provision order or regulation as from time to time amended modified extended or
          re-enacted whether before or after the date of this Agreement and to all
          statutory instruments orders regulations and directives modifying or extending the same.
        </p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">13.8.</p>
        <p class="paragraph">
          The construction, validity and performance of this Agreement shall be governed by the laws
          of England and Wales and the parties submit to the exclusive jurisdiction of the courts of
          England and Wales to resolve any dispute between them.
        </p>
      </div>
      <div class="sign">
        <p>Read and agreed:</p>
        <br>
        <div class="sign-spot-div">
          <div class="sign-spot-div_left">
            <hr>
            <p>For and on behalf of</p>
            <p>SOUNDVAULT LIMITED</p>
          </div>
          <div class="sign-spot-div_right">
            <hr>
            <p>For and on behalf of </p>
            <p>LICENSOR</p>
          </div>
        </div>
        <div>
        </div>
      </div>
      <div class="pb">
        <p class="tac">IMPORTANT: Please ensure you complete (below) Schedule 3 (track info) and also sign either<br>
          Schedule 5 or 6 in reference to your track’s Content ID Status.</p>
        <br>
        <p class="tac">SCHEDULE 1</p>
        <p class="tac">Definitions</p>
      </div>
      <div class="paragraph-parent">
        <p class="paragraph-name">1.</p>
        <p class="paragraph">
          The following definitions apply in this Agreement:
        </p>
      </div>
      <div class="definitions">
        <p><strong>“Agreement”</strong><br>
          this agreement and any and all schedules, annexures and exhibits attached to it or incorporated in it by reference;
        </p>
        <p><strong>“Artist Materials”</strong><br>
          any names, artwork, data and/or content including biographical information about performers or songwriters
          supplied by or on behalf of the Licensor to SoundVault for use in connection with the sub licence of the
          Tracks permitted under this Agreement;
        </p>
        <p><strong>“Broadcast Quality”</strong><br>
          means MP3 – 320kbps, FLAC, AIFF, AAC or Wav audio file digitised to the highest standard not being
          less than 16bits per second / 44.1kHz directly from original master recording, suitable for
          use in the broadcast industry;
        </p>
        <p><strong>“Campaign Term”</strong><br>
          is the period (normally 16 weeks) when a track appears on the website for promotion.
          Dates vary on a track by track basis and are determined in advance via email and agreed between both parties;
        </p>
        <p><strong>“Channel”</strong><br>
          means a Subscriber’s social media channel or channels controlled and operated by the Subscriber
          for example YouTube channel, Facebook channel etc.;
        </p>
        <p><strong>“Licensed Usage”</strong><br>
          means the uses as set out in Schedule 2;
        </p>
        <div class="footer">
          <p>
            Company registration Number (England & Wales) 00602518<br>
            Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
          </p>
          <p class="tac">6</p>
        </div>
      </div>
    </div>
    <div class="page">
        <br><br><br>
      <div class="definitions">
        <p><strong>“Promotional Artist Tracks”</strong><br>
          sound recordings and their underlying musical compositions comprising music and / or lyrics owned
          and / or controlled by Licensor and submitted to SoundVault by the Licensor for exploitation
          under the terms of this Agreement.
        </p>
        <p><strong>“Sample”</strong><br>
          means the reuse of a portion of a sound recording in another recording.
        </p>
        <p><strong>“Sub-Licence”</strong><br>
          means a synchronisation licence granted by SoundVault to a third party for use of a Track
          for one or more of the uses described in the Licenced Usage;
        </p>
        <p><strong>“Subscriber”</strong><br>
          means each third party holder of a valid subscription for the SyncVault service from time to time.
        </p>
        <p><strong>“Term”</strong><br>
          has the meaning given in Clause 7.1
        </p>
        <p><strong>“Territory”</strong><br>
          means the world;
        </p>
        <p><strong>“The Program”</strong><br>
          is defined as the program contemplated in this Agreement whereby YouTube identifies your Content
          that third parties have put on YouTube and then advertising and sponsorships are placed in and
          around your Content, thereby "monetizing" your Content.
        </p>
        <p><strong>“Tracks”</strong><br>
          means any sound recordings and their underlying musical compositions comprising music and
          / or lyrics which are owned and / or controlled by Licensor and submitted to SoundVault
          by the Licensor for exploitation under the terms of this Agreement;
        </p>
        <p><strong>“Track Metadata”</strong><br>
          means the underlying information about any Track including but not limited to artist,
          musician, producer, songwriter and music publisher names and shares for each Track;
        </p>
        <p><strong>“SyncVault Music campaign”</strong><br>
          means SyncVault’s paid promotional campaign service that incentivises YouTubers to select promotional
          tracks from the Music section on the website and sync to their videos with the potential for them
          to get paid for using the music based on the number of views they receive.
        </p>
        <p><strong>“Video”</strong><br>
          means audiovisual content created or controlled by Subscribers and published on YouTube
          or other social media platforms;
        </p>
        <p><strong>“Website”</strong><br>
          means www.SyncVault.com and any and all other domains that point to SyncVault.com
        </p>
        <p><strong>“YouTube”</strong><br>
          is defined as the website located at www.YouTube.com, which is owned and operated by Google.
          This definition of YouTube includes all consumer facing third party digital websites,
          URL's, domains, and applications whether accessible from the internet, mobile or
          wireless networks, via computer, mobile device, console or otherwise, that display
          and/or contain YouTube videos and/or embeds, including but not limited to Facebook,
          Vimeo, Instagram and any website under the sun which contains YouTube hosted and/or embedded videos.
          Please note that YouTube and Google are trademarks or registered trademarks of Google, Inc.
          in the United States and/or other countries.
        </p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">7</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <p class="tac pb">SCHEDULE 2</p>
      <p class="tac pb">Licensed Usage</p>
      <p class="paragraph">SoundVault may Promote and Sub-Licence Tracks for the Territory for synchronisation
        with editorial, sponsored content and branded content (subject to any limited restrictions on
        specific repertoire and excluding for the avoidance of doubt paid for advertising) on a
        non-exclusive basis for digital only social media use provided always that SoundVault may
        not make the Tracks available for use in isolation of any other media.
      </p>
      <p class="tac pb">SCHEDULE 3</p>
      <p class="tac pb">Promotional Artist Tracks/s</p>
      <p class="paragraph pw">Please complete:</p>
      <table class="promotional-table">
        <tr>
          <th>Artist Name</th>
          <th>Track Name</th>
          <th>Budget</th>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
      <p class="promotional-italic">Add more rows to meet number of designated tracks as required.</p>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">8</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <p class="tac pb">SCHEDULE 4</p>
      <p class="tac pb">Promotional Artist Assets Checklist</p>
      <br>
      <div class="promotional-artist">
        <p class="pb">Every track supplied to SyncVault will require completion of an Asset Form that will be<br>
          provided separately and via email to Licensor and will include the following:</p>
        <p class="pb">Contact Information</p>
        <ul>
          <li>Company name</li>
          <li>Company Address</li>
          <li>Contact name</li>
          <li>Email address</li>
          <li>Mobile number</li>
        </ul>
        <p class="pb">Artist Assets</p>
        <ul>
          <li>Biography - up to 150 words. Please include artist’s interests / hobbies</li>
          <li>Press quotes - if available</li>
          <li>Audio files  inc. instrumental - WAV 24 bit/44.1kHz or mp3 – 320 kbps</li>
          <li>Artwork -  600x600 and 1920x600 .png or .jpeg plus any additional images for gallery</li>
          <li>Social Media links - YouTube, Instagram, TikTok, Facebook etc.</li>
          <li>Streaming platform links - Spotify, Apple Music, Deezer, SoundCloud, Amazon</li>
          <li>Music video link - YouTube</li>
          <li>Live / live streaming events, if applicable</li>
        </ul>
        <p class="pb">Metadata</p>
        <p class="paragraph">As per SyncVault metadata spreadsheet to be provided separately.</p>
      </div>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">9</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <p class="tac pb">SCHEDULE 5</p>
      <table class="typeA-table">
        <tr>
          <th>SOUNDVAULT CONTENT ID MANAGEMENT ASSIGNMENT</th>
        </tr>
        <tr>
          <td>
            <div class="paragraph-parent">
              <p class="paragraph-name">1)</p>
              <p class="paragraph">
                You hereby grant to SoundVault, in the Territory, the exclusive right to administer all information
                and payments received from YouTube in connection with the reproduction, distribution,
                public performance, public display, and synchronization of your Content with user-uploaded
                videos, and activate and enrol such Content in the Program.
                This grant includes all necessary rights to manage the Content on SoundVault's part as
                required to carry out the foregoing. We are not expressly licensing your Content to
                the users of YouTube outside of the SyncVault Website and this Agreement does not
                expressly waive your rights against individuals who infringe on your copyrights or
                otherwise grant to them a synchronization license or any other license.
                This Agreement does not transfer any ownership of your copyrights or other intellectual property.
                Furthermore, we support the position that YouTube must pay public performance royalties to
                the applicable Performing Rights Organizations ("PROs").
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">2)</p>
              <p class="paragraph">
                You grant to SoundVault the right to change the duration, transcode, resize and reformat your
                Content insofar as necessary to repurpose, watermark, and/or fingerprint the Content
                for monitoring on YouTube in accordance with the purpose of this Agreement.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">3)</p>
              <p class="paragraph">
                The rights herein are granted on an exclusive basis during the Campaign Term and
                for the first 30 days thereafter. The Program is limited to YouTube advertising
                and sponsorship monetization only.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">4)</p>
              <p class="paragraph">
                Whilst Promotional Artists tracks are made available to Subscribers, they must publicly
                publish the video with the synced track on their YouTube channel within the Campaign term.
                In doing so, the rights for the sync in that video are granted in perpetuity.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">5)</p>
              <p class="paragraph">
                At the end of the Campaign term, SoundVault will report to the Licensor all YouTube channels
                and videos that Subscribers have licensed and used within the Campaign term.
                The videos in these channels must remain free to monetise and cannot be claimed.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">6)</p>
              <p class="paragraph">
                If a Subscriber downloads a track during the Campaign term but does not publicly publish the
                video with the synced track onto their YouTube channel until after the Campaign term,
                then it will be deemed by SoundVault that the Subscriber will lose the right to monetise.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">7)</p>
              <p class="paragraph">
                Content ID Royalties & Accounting: SoundVault shall pay to you Your Share of YouTube ‘AdSense’
                Advertising Revenue of Eighty-Seven and a Half Percent (87.5%) of the gross revenue
                actually received by SoundVault on your behalf, and derived directly from the exploitation
                of the rights granted by you herein, and within thirty (30) days of the close of each calendar
                quarter either via PayPal, check, or wire transfer, to be determined by SoundVault in its
                sole discretion. An accounting statement showing all monies due to you for each such
                calendar quarter shall accompany such payment. The royalties contained herein shall be
                the only consideration due you for the rights granted herein and no other forms of compensation
                shall be due to you from SoundVault, including but not limited to mechanical or public
                performance royalties. You shall still be entitled to collect public performance royalties
                directly from your affiliated performing rights society(ies).
              </p>
            </div>
          </td>
        </tr>
      </table>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">10</p>
      </div>
    </div>
    <div class="page">
      <br><br><br>
      <p class="tac pb">SCHEDULE 6</p>
      <table class="typeA-table">
        <tr>
          <th>CONTENT ID RESTRICTED ‘OWNERSHIP TRANSFER’ ACCEPTANCE </th>
        </tr>
        <tr>
          <td>
            <div class="paragraph-parent">
              <p class="paragraph-name">1)</p>
              <p class="paragraph">
                You confirm that either you and/or your designated third-party agent has official
                YouTube Studio Content ID Management Control Access to manage and release Content ID claims.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">2)</p>
              <p class="paragraph">
                You agree to officially accept and allow OR ensure your designated third-party agent accepts
                and allows, a territory ownership request in ‘ownership transfers’ on YouTube studio from SoundVault.
                Acceptance of the ‘ownership transfers’ will enable SoundVault to manage Content ID
                ownership of a small territory only (e.g.: Bahrain).  This ‘ownership transfer’
                is throughout the duration of the Campaign term only, to enable SoundVault to release all
                claims that go through its platform.  (This will not affect your track monetisation elsewhere).
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">3)</p>
              <p class="paragraph">
                You understand that at the end of the Campaign term, SoundVault will remove its ownership to that
                small territory, and all those videos it has released under that ownership will
                remain claim free in perpetuity.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">4)</p>
              <p class="paragraph">
                For the avoidance of doubt, after the Campaign term no syncing of the track is permitted by
                any SoundVault subscriber.
              </p>
            </div>
            <div class="paragraph-parent">
              <p class="paragraph-name">5)</p>
              <p class="paragraph">
                If a Subscriber downloads a track during the Campaign term but does not publicly publish the
                video with the synced track onto their YouTube channel until after the Campaign term,
                then it will be deemed by SoundVault that the Subscriber will lose the right to monetise.
              </p>
            </div>
          </td>
        </tr>
      </table>
      <br>
      <table class="typeB-table">
        <tr>
          <th>
            TICK 1 BOX ONLY and sign below to finalise which Content ID option you agree to:<br><br>
            Schedule 5:  I wish SoundVault to Manage My Content ID for the duration of my track’s
            promotional campaign/s (most popular).<br><br>
            Schedule 6:  I wish my content ID to be controlled by my CID Manager / Distributor and I will provide
            all relevant contact details to SoundVault via email.<br><br>
            Signed:<br>
            Name:<br>
            Date:
          </th>
        </tr>
      </table>
      <div class="footer">
        <p>
          Company registration Number (England & Wales) 00602518<br>
          Registered office: 303 The Pill Box, 115 Coventry Road, London, E2 6GH, United Kingdom.
        </p>
        <p class="tac">11</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.page {
  width: 715.5px;
  height: 1122px;
  margin: 0px 40px 0px 40px;
  background: white;
  position: relative;
  .paragraph-parent{
    display: flex;
  }
  .paragraph-name{
    margin-right: 25px;
    font-size: 12px;
    font-family: 'Nunito Light';
  }
  .paragraph{
    text-align: justify;
    font-size: 12px;
    font-family: 'Nunito Light';
  }
  h2 {
    font-size: 12px;
    font-family: 'Nunito Bold';
  }
  .mr25{
    margin-right: 25px;
  }
  .pw{ //parent with margin
    margin-left: 45px;
  }
  .pb{ //paragraph bold
      font-size: 12px;
      font-family: 'Nunito Bold';
  }
  .tac{ //text alight center
    text-align: center;
  }
  .sign{
    margin-left: 45px;
    margin-right: 45px;
    font-size: 12px;
    font-family: 'Nunito Light';
  }
  .sign-spot-div{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .definitions{
    font-size: 12px;
    font-family: 'Nunito Light';
  }
  .promotional-artist{
    font-size: 12px;
    font-family: 'Nunito Light';
    margin-left: 45px;
  }
  .promotional-table{
    margin-left: 45px;
    font-size: 12px;
    font-family: 'Nunito Bold';
    border-collapse: collapse;
    width: 93%;

    td, th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 8px;
      width: 150px;
      height: 30px;
    }
  }
  .typeA-table{
    font-size: 12px;
    font-family: 'Nunito Bold';
    border-collapse: collapse;
    margin-left: 45px;
    width: 93%;

    td, th {
      border: 1px solid #dddddd;
      padding: 8px;
      width: 150px;
      height: 30px;
    }
    th{
      text-align: center;
    }
  }
  .typeB-table{
    font-size: 14px;
    font-family: 'Nunito Bold';
    border-collapse: collapse;
    margin-left: 45px;
    width: 93%;

    td, th {
      border: 1px solid #dddddd;
      padding: 8px;
      width: 150px;
      height: 30px;
      text-align: left;
    }
  }
  .contract-logo{
    margin: auto;
    display: block;
  }
  .promotional-italic{
    text-align: right;
    font-size: 10px;
    font-family: 'Nunito Italic';
  }
  .footer {
    bottom: 0;
    position: absolute;
    font-family: 'Nunito Light';
    font-size: 10px;
    width: 100%;
  }
}
</style>
